import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { SendInsurancePayload, SendedLaSegundaResponse } from './validate-insurance.types';
import { transformIntoQueryParamString } from '@old/utils/service';

type Config = { type: 'lasegunda' | 'galicia' | 'fedpatronal' | 'swissre' };

// deprecated service ref.: postLaSegundaInsurance_DEPRECATED
export async function insuranceValidateService({ query: rawQuery }: SendInsurancePayload, config: Config) {
  const query = transformIntoQueryParamString(rawQuery);

  const ENDPOINT_MAP = {
    lasegunda: ENDPOINT.INSURANCE_LASEGUNDA_VALIDATE,
    galicia: ENDPOINT.INSURANCE_GALICIA_VALIDATE,
    fedpatronal: ENDPOINT.INSURANCE_FED_PATRONAL_VALIDATE,
    swissre: ENDPOINT.INSURANCE_SWISS_RE_VALIDATE,
  };

  const { response, data } = await BACKEND.post<SendedLaSegundaResponse>(ENDPOINT_MAP[config.type], {
    query,
  });

  return {
    response,
    summary: data,
  };
}
